<template>
    <div class='events-section'>
        <div class="details box is-radiusless is-marginless is-shadowless">
            <h4 class="is-size-5">Projekthandlinger</h4>
            <br>

            <accept-price-offer-project-action style="display: inline-block;" v-if="canAcceptPriceOffer" :project="project" @accepted="onAccept" />

            <finalize-project-action style="display: inline-block;" v-if="canFinalizeProject" :project="project" @finalized="onFinalize" />

            <post-price-offer-project-action style="display: inline-block;" v-if="canPostPriceOffer" :project="project" @posted="onPostPrice" />

            <cancel-project-action style="display: inline-block;" v-if="canCancelProject" :project="project" @cancelled="onCancel" />

            <p v-if="hasNoActions">Du har ikke mulighed for at gøre yderligere ved projektet lige nu.</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

</style>

<script>
    import { mapGetters } from 'vuex';
    import AcceptPriceOfferProjectAction from '@/taskflex/conversations/components/Projects/ProjectActions/AcceptPriceOfferProjectAction';
    import CancelProjectAction from '@/taskflex/conversations/components/Projects/ProjectActions/CancelProjectAction';
    import FinalizeProjectAction from '@/taskflex/conversations/components/Projects/ProjectActions/FinalizeProjectAction';
    import PostPriceOfferProjectAction from '@/taskflex/conversations/components/Projects/ProjectActions/PostPriceOfferProjectAction';

    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'isStudent',
                'isCustomer',
                'currentUserAccount',
            ]),

            ...mapGetters('conversations', {
                conversation: 'activeConversation',
                isLoading: 'isLoadingConversation',
            }),

            hasNoActions() {
                return !this.canPostPriceOffer
                    && !this.canAcceptPriceOffer
                    && !this.canCancelProject
                    && !this.canFinalizeProject;
            },

            canPostPriceOffer() {
                return this.isStudent
                    && this.project.accepted_price === null
                    && this.project.price_accepted_at === null
                    && this.project.cancelled_at === null
                    && this.project.finalized_at === null;
            },

            canAcceptPriceOffer() {
                return this.isCustomer
                    && this.project.offered_price
                    && this.project.accepted_price === null
                    && this.project.price_accepted_at === null
                    && this.project.cancelled_at === null
                    && this.project.finalized_at === null;
            },

            canCancelProject() {
                return (this.isCustomer || this.isStudent)
                    && this.project.accepted_price === null
                    && this.project.price_accepted_at === null
                    && this.project.cancelled_at === null
                    && this.project.finalized_at === null;
            },

            canFinalizeProject() {
                return this.isStudent
                    && this.project.accepted_price
                    && this.project.price_accepted_at
                    && this.project.cancelled_at === null
                    && this.project.finalized_at === null;
            },
        },

        methods: {
            onAccept() {
                window.location.reload(true);
            },

            onCancel() {
                window.location.reload(true);
            },

            onFinalize() {
                window.location.reload(true);
            },

            onPostPrice() {
                window.location.reload(true);
            },
        },

        components: {
            AcceptPriceOfferProjectAction,
            CancelProjectAction,
            FinalizeProjectAction,
            PostPriceOfferProjectAction,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectActions.vue